import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { isDummyRoom } from "@/lib/chillnn/is-dummy-room";
import type { Room, RoomDummy } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { TableRow } from "@/components/ui/table/table";

import { RoomListPageTableItem } from "./item";

type Props = {
	room: RoomDummy | Room;
	hotelID: string;
	onDeleteRoom: (roomID: string) => void;
};

export const RoomListPageTableDefaultItem = ({ room, hotelID, onDeleteRoom }: Props) => {
	const navigate = useNavigate();

	const onTransitionToEdit = useCallback(() => {
		if (isDummyRoom(room)) {
			const editRoomPagePath = generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DUMMY, {
				hotelID,
				roomID: room.roomID,
			});
			navigate(editRoomPagePath);
		} else {
			const editRoomPagePath = generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT, {
				hotelID,
				roomID: room.roomID,
			});
			navigate(editRoomPagePath);
		}
	}, [hotelID, navigate, room]);

	const handleClick = useCallback(() => {
		onTransitionToEdit();
	}, [onTransitionToEdit]);

	return (
		<TableRow className="hover:cursor-pointer" onClick={handleClick}>
			<RoomListPageTableItem room={room} hotelID={hotelID} onDeleteRoom={onDeleteRoom} />
		</TableRow>
	);
};

RoomListPageTableDefaultItem.displayName = "RoomListPageTableDefaultItem";
